// --------CORE------
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// ----COMPONENTS----

// ------PIPES-------
import { ToPipePipe } from './pipes/toPipe.pipe';
import { SlickDirective } from './directives/slick.directive';
import { PhonePipe } from './pipes/phone.pipe';
import { ValidationComponent } from './form/components/validation';
import { DatepickerDirective } from './directives/datepicker.directive';
import { AlertsUtilitiesAppService } from './services/utilities/alerts-app.service';
import { UtilitiesService } from './services/utilities.service';
import { ScrollAppService } from './services/utilities/scroll.service';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { saveDataSearchUtil } from './services/utilities/saveDataSearchUtil.service';
import { NgLetDirective } from './directives/ng-let.directive';
import { DateFromIsoPipe } from './pipes/date-from-iso.pipe';
import { MinutesToHoursPipe } from './pipes/minutes-to-hours.pipe';
import { CurrencyExchangePipe } from './pipes/monedaTransform.pipe';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        // ----COMPONENTS----
        ValidationComponent,
        // ------PIPES-------
        ToPipePipe,
        PhonePipe,
        SafeHtmlPipe,
        DateFromIsoPipe,
        CurrencyExchangePipe,

        // ----DIRECTIVES----
        SlickDirective,
        DatepickerDirective,
        NgLetDirective,
        MinutesToHoursPipe,
        // DirectionsMapDirective,
    ],
    exports: [
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        // ----COMPONENTS----
        ValidationComponent,
        // ------PIPES-------
        ToPipePipe,
        PhonePipe,
        SafeHtmlPipe,
        DateFromIsoPipe,
        CurrencyExchangePipe,

        // ----DIRECTIVES----
        SlickDirective,
        DatepickerDirective,
        NgLetDirective,
        MinutesToHoursPipe,
        // DirectionsMapDirective,
    ],
    providers: [
        AlertsUtilitiesAppService,
        UtilitiesService,
        ScrollAppService,
        saveDataSearchUtil
    ]
})
export class CoreModule { }
